<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" 
			:pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageSubtitle="pageSubtitle" :pageTitle="pageTitle" :pageIcon="pageIcon">
		</header-layout>
		<div class="container mt-n10 ">
			<div class="card mb-4" style="width:100%">
				<div class="card-body">
					<div class="row">
						<div class="col-xl-12">
							<div class="row">
								<div class="col-xl-5"><!-- Profile picture card-->
								<div class="card"> <!-- account -->
									<div class="card-header">{{ user.username }}</div>
									<div class="card-body">
										<div class="list-group">
											<li class="list-group-item">
												<fa icon="clock" style="color: green;"/>
												{{ $t('user.lastConnection') }}
												<span class="pull-right text-muted small">
													<em>
														{{$moment(user.lastConnection).format($store.getters.formatDate)}}
													</em>
												</span>
											</li>
											<li class="list-group-item">
												<fa icon="newspaper" style="color: green;"/>
												{{ $t('user.lastIP') }}
												<span class="pull-right text-muted small">
													<em>{{ user.lastIP }}</em>
												</span>
											</li>
											<li class="list-group-item">
												<div class="col-md">
													<fa v-if="user.enabled" icon="check-square" style="color: green;"/>
													<fa v-else icon="square" style="color: red;"/>
													{{ $t('user.enabled') }}
												</div>
												<div class="col-md">
													<fa v-if="user.accountExpired" icon="check-square" style="color: green;"/>
													<fa v-else icon="square" style="color: red;"/>
													{{ $t('user.accountExpired') }}
												</div>
												<div class="col-md">
													<fa v-if="user.accountLocked" icon="check-square" style="color: green;"/>
													<fa v-else icon="square" style="color: red;"/>
													{{ $t('user.accountLocked') }}
												</div>
											</li>
										</div>
									</div>
									
								</div><!-- account -->
								<br> 
								<div class="card"><!-- twoFactor -->
									<!-- <div class="card-header">
										{{ $t('user.profile.two.factor.authentication.label') }}
									</div>
									<div class="card-body">

										<div class="row p-1">
											<div class="col-lg-12">
												<form class="mb-1">
													<p>{{ $t('user.profile.two.factor.authentication.message') }}</p>
													<div class="form-check">
														<input class="form-check-input" v-model="mfaEnabled" value="on" @click="activateMfa()" id="twoFactorOn" type="radio" name="mfaEnabled">
														<label class="form-check-label" for="twoFactorOn">{{ $t('user.profile.two.factor.authentication.on') }}</label>
													</div>
													<div class="form-check" >
														<input class="form-check-input" v-model="mfaEnabled" value="off" @click="saveChanges()" id="twoFactorOff" type="radio" name="mfaEnabled">
														<label class="form-check-label" for="twoFactorOff">{{ $t('user.profile.two.factor.authentication.off') }}</label>
													</div>
												</form>
											</div>
										</div>

									</div> -->
									
								</div> <!-- twoFactor -->


								</div><!-- fin Profile picture card-->

								<div class="col-xl-7"><!-- Account details card-->
									<div class="card mb-4"> <!-- Info-->
										<div class="card-header">
											{{ $t('user.profile.detail') }}
											<button class="btn btn-primary btn-sm" @click="modalToggle('PWD')" style="float: right;">
												<fa icon="lock"/>&nbsp;
												{{ $t('default.editPwd') }}
											</button>
										</div>
										<div class="card-body">
											<form>
												<!-- Form Row-->
												<div class="form-row">
													<div class="form-group col-md-5">
														<label class="small mb-1" for="inputUsername">
															{{$t('user.username')}}
														</label>
														<input class="form-control" id="inputUsername" type="text" :placeholder="$t('user.username')" :value="user.username" disabled>
													</div>
													
													<div class="form-group col-md-7">
														<label class="small mb-1" for="inputEmailAddress">
															{{ $t('user.email') }} 
														</label>
														<input class="form-control" id="inputEmailAddress" type="email" :placeholder="$t('user.email')" :value="user.email" disabled>
													</div>
													<div class="form-group col-md-5">
														<label class="small mb-1" for="inputUserTitle">
															{{$t('user.userTitle')}}
														</label>
														<input class="form-control" id="inputUserTitle" type="text" :placeholder="$t('user.userTitle')" :value="user.userTitle" disabled>
													</div>

													<div class="form-group col-md-7">
														<label class="small mb-1" for="inputPersonId">
															{{ $t('user.personId') }} 
														</label>
														<input class="form-control" id="inputPersonId" type="text" :placeholder="$t('user.personId')" :value="prsLinkedName" disabled>
													</div>
													<div class="form-group col-md-12">
														<label class="small mb-1" for="inputRole">
															{{ $t('user.roles') }} 
														</label>
														<div class="list-group">
															<h4 class="d-inline">
																<b-badge v-for="role in user.roles" :key="role.id" pill class="m-1" variant="success" style="color:white;">
																	{{ role ? role.name : $t('default.modal.no.role') }}
																</b-badge>
															</h4>
														</div>
													</div>
												</div>
											</form>
											<!-- btn Row-->
											<div class="btn-row">
												<div class="btn-group mt-4 mb-0" style="float: right;">
													<button class="btn btn-primary btn-sm" @click="modalToggle('INFO')" >
														<fa icon="edit"/>&nbsp;
														{{ $t('default.button.update') }}
													</button>
												</div>
											</div>

										</div>
									</div> <!-- Fin Info-->

								</div> <!-- fin Account details card -->

							</div> <!-- fin row -->
							<b-tabs content-class="mt-3">
								<b-tab :title="$t('user.profile.personId')"> <!-- tab person info -->
									<div class="row">
										<div class="col-xl-12">
											<div class="card mb-4">
												<div class="card-body">

													<!-- <form>
														<div class="form-row">
															<div class="col-md-6">
																<div class="form-group">
																	<label for="InputFirstNameP">
																		{{ $t('prsindividual.firstName')}}
																	</label>
																	<input id="InputFirstNameP" type="text" class="form-control" required="" :value="personInfo.firstName" disabled/>
																</div>
															</div>
															<div class="col-md-6">
																<div class="form-group">
																	<label for="InputLastNameP">
																		{{ $t('prsindividual.lastName')}}
																	</label>
																	<input id="InputLastNameP" type="text" class="form-control" required="" :value="personInfo.lastName" disabled/>
																</div>
															</div>
															<div class="col-md-6">
																<div class="form-group">
																	<label for="inputBirthPlace">
																		{{ $t('prsindividual.birthPlace')}}
																	</label>
																	<input id="inputBirthPlace" type="text" :value="personInfo.birthPlace" class="form-control" required="" disabled/>
																</div>
															</div>
															<div class="col-md-6">
																<div class="form-group">
																	<label for="inputProfession">
																		{{ $t('prsindividual.profession')}}
																	</label>
																	<input id="inputProfession" type="text" class="form-control" :value="personInfo.profession" disabled>
																</div>
															</div>
															<div class="col-md-12">
																<div class="form-group">
																	<label for="textareaBioDescription">
																		{{ $t('prsindividual.bioDescription')}}
																	</label>
																	<textarea type="text" id="textareaBioDescription" placeholder="ajoutez une descriptiom biographique" :value="personInfo.bioDescription" rows="10" class="form-control" disabled/>
																</div>
															</div>
														</div>
													</form> -->

													<!-- <router-link v-if="personInfo.className" :to="{ name: (personInfo.className.toString().substring(personInfo.className.toString().lastIndexOf('.')+1)).toLowerCase()+'show', params: {itemId: this.personInfo.id} }" class="btn btn-primary" >
													

														<fa icon="info"/>
														&nbsp; {{ $t('user.profile.prsPerson') }}
													</router-link> -->
												</div>
											</div>
										</div> <!-- fin person info -->
									</div>
								</b-tab> <!-- tab person info -->
								<b-tab :title="$t('user.imgSignature')" active> <!-- tab Sign -->
									<div class="row">
										<div class="col-xl-12">
											<div class="card">
												<div class="card-header">
													<!-- {{ $t('user.imgSignature') }} -->
													<div style="float:right" v-if="!showSignaturePad">
														<button class="btn btn-primary btn-sm" @click="showSignaturePad = true; modalType = 'signPad'">
															<fa icon="user-plus"/>
															&nbsp;{{ $t('default.button.signPad') }}
														</button>
														&nbsp;
														<button class="btn btn-sm" @click="modalType = 'signPadPlus'; modalToggle('signPadPlus')">
															<fa icon="upload"/>
															&nbsp;{{ $t('default.button.signPadPlus') }}
														</button>
													</div>
												</div>
												<div class="card-body text-center">
													
													<div class="col-md-12" v-if="!showSignaturePad"><!-- Fin View Sign -->
														<img :src="user.imgSignature" width="100%">
													</div><!-- Fin View Sign-->

													<div class="col-md-12" v-if="showSignaturePad">
														<!-- VueSignaturePad -->
														<div class="form-group">
															<div class="buttons">
																<button class="btn btn-warning btn-xs" @click="undo">
																	<fa icon="undo"/>
																	&nbsp;{{$t('default.button.undo')}}
																</button>
																<button class="btn btn-primary btn-xs" @click="change">
																	{{$t('signature.color.label')}}
																</button>
																<button class="btn btn-info btn-xs" @click="resume">
																	{{$t('signature.color.label')}}
																</button>
															</div>
															<div class="container">
																<VueSignaturePad
																id="signature"
																width="100%"
																height="100%"
																ref="signaturePad"
																:options="options"
																/>
															</div>
															<div class="buttons">
																<button class="btn btn-success btn-sm" @click="axiosPost">
																	<fa icon="check"/>
																	&nbsp;{{ $t('default.button.submit') }}
																</button>
																<button type="button" class="btn btn-danger btn-sm" @click="showSignaturePad = false">
																	<fa icon="times"/>
																	&nbsp;{{ $t('default.button.cancel') }}
																</button>
															</div>
														</div>
													</div> <!-- Fin VueSignaturePad -->

													<div class="col-md-12" style="float:right" v-if="!showSignaturePad">
														<button v-if="user.imgSignature" class="btn btn-danger btn-sm" :disabled="loading" @click="modalType = 'DEL'; axiosPost();">
															<!-- submitFileSignature() -->
															<fa icon="trash"/>
															<span v-show="loading" class="spinner-border spinner-border-sm"/>
														</button>
														&nbsp;
														<button class="btn btn-primary btn-sm" @click="modalToggle('uploadImgSign')">
															<fa icon="upload"/>
														</button>
													</div>
													
												</div>

											</div>
										</div>
									</div>
								</b-tab> <!-- tab Sign -->

							</b-tabs>

						</div> <!--col-xl-12 -->
					</div> <!--row -->
				</div> <!--card-body -->
			</div> <!--card mb-4 -->

			<!-- ModalProfil  -->
			<div ref="modalProfil" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered modal-lg"
					role="document">
					<div class="modal-content">
						
						<div class="modal-header">
							<h5 class="modal-title" v-if="modalType == 'INFO'">
								{{ $t('default.edit', {obj:$t('user.profile.label') } ) }}
							</h5>
							<h5 class="modal-title" v-if="modalType == 'PWD'">
								{{ $t('default.editPwd') }}
							</h5>
							<h5 class="modal-title" v-if="modalType == 'uploadImgSign' || modalType == 'signPadPlus'">
								{{ $t('default.uploadImgSign') }}
							</h5>
							<b-button type="button" variant="close" @click="modalToggle('uploadImgSign') "/>
						</div>
						<div class="modal-body">
							<b-container v-if="modalType === 'uploadImgSign'">
								<form role="form" id="modalFormUpload" @submit.prevent="handleSubmit" enctype="multipart/form-data">
								<!-- Flash -->
								<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
								<div class="row d-flex justify-content-center">
									<div class="col-md-12" v-if="modalType === 'uploadImgSign'">
										<div class="form-group">
											<label for="imgSignature">
												{{ $t('user.imgSignature') }}
											</label>
											<input ref="fileSign" type="file" @change="handleFileUpload($event)" class="form-control"
											:readonly="dataMapShow.readOnlyShow" required/>
											<!-- <input 
												ref="file" type="file"
												:lang="language"
												class="form-control"
												:placeholder="$t('default.form.file.placeholder')"
												:drop-placeholder="$t('default.form.file.placeholder')"
												:readonly="dataMapShow.readOnlyShow"
												@change="handleFileUpload($event)"
											required/> -->
											<!-- <b-form-file 
											:lang="language" 
											:placeholder="$t('default.form.file.placeholder')" 
											:drop-placeholder="$t('default.form.file.placeholder')" 
											id="file" 
											ref="file" 
											@change="handleFileUpload()" 
											accept="image/png, image/jpeg" required/> -->
										</div>
									</div>
								</div>
								</form>
							</b-container>
							<b-container v-if="modalType === 'INFO' || modalType === 'PWD' ">

								<form role="form" id="modalForm" @submit.prevent="handleSubmit">
									<!-- Flash -->
									<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
									<div class="row d-flex justify-content-center ">
										<div v-for="attr in dataMapShow.attrsList" :key="attr.attrName" class="col-md-12">
											<div class="form-group" v-if="attr.attrDisplay">
												<label>{{ $t(dataMapShow.infos.instanceClass + '.' + attr.attrName )}}{{attr.attrRequired ? '*':''}}</label>
												
												<!-- <input v-if="attr.attrType == 'String'" type="text" :class="`form-control ${attr.attrCol}`" :name="attr.attrName" v-model="attr.attrValue" :required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow"/> -->

												<input v-if="attr.attrType == 'String'" type="text" :class="`form-control ${attr.attrCol}`"
												:id="`input-${attr.attrName}`" :name="attr.attrName"
												v-model="attr.attrValue" :required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow"/>

												<input v-if="attr.attrType == 'password'" type="password" :class="`form-control ${attr.attrCol}`" :name="attr.attrName" v-model="attr.attrValue" :required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow">
											</div>
										</div>
									</div>
								</form>
								<!-- {{ dataMapShow}} -->
							</b-container>
							<signature :user="user" :fileString="fileString" v-if="modalType === 'signPadPlus'"/>

						</div> <!-- modal-body  -->
						<div class="modal-footer">

							<div class="row d-flex justify-content-end mb-3">
								<input type="hidden" id="id" name="id" :value="user.id" required>

								<!-- INFO -->
								<div v-if="!dataMapShow.readOnlyShow" class="mr-3">
									<!-- axiosPost -->
									<button class="btn btn-success" :disabled="loading" @click="handleSubmit">
										<span v-show="loading" class="spinner-border spinner-border-sm"/>

										<span v-if="!dataMapShow.infos.id">
											{{ $t('default.button.create') }}
										</span>
										<span v-if="dataMapShow.infos.id">
											<fa icon="check"/>
											{{ $t('default.button.update') }}
										</span>
									</button>
								</div>
								<!-- Sign -->
								<b-button v-if="modalType == 'modalUploadSignature'" class="btn btn-success btn-sm" :disabled="loading" @click="submitFileSignature" >
									<span v-show="loading" class="spinner-border spinner-border-sm"/>
									<span v-if="user.id">
										<fa icon="pencil"></fa>
										{{ $t("default.button.update")}}
									</span>
								</b-button>

								<button type="button" class="btn btn-danger ml-1" @click="modalToggle('uploadImgSign')">
									<fa icon="times"/> &ensp;
									{{ $t('default.button.cancel') }}
								</button>

							</div>

						</div> 

					</div> <!-- modal-content  -->
				</div> <!-- modal-dialog  -->
			</div> <!-- ModalProfil  -->

		</div> <!--container mt-n10 -->
	</div> <!--content_body -->
</template>
<script>
	// import HeaderCompact from '@/layouts/templates/HeaderCompact.vue';
	import HeaderCompact from '@/layouts/templates/Header.vue';
	// import { linkActivationMixin } from '@/mixins/linkActivationMixin'
	import Signature from '@/modules/admin/views/Signature';

	const instanceClass = 'user'

	export default {
		name: 'Profile',
		components: {
			'header-layout': HeaderCompact,
			'signature': Signature
		},
		// mixins: [linkActivationMixin],
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t("user.profile.label"),
				pageTitle: this.$t("user.profile.list"),
				pageIcon: 'user-circle',
				user: {},
				prsLinkedName: '',
				dataMapShow: {
					infos: {
						instanceClass: instanceClass
					},
					attrsList: [],
					readOnlyShow: false
				},
				loading: false,
				active: false,
				showSignaturePad: false,
				modalUploadSignature: false,
				modalType: 'INFO',
				userId: this.$route.params.userId || this.$store.getters.uid,
				file: '',
				fileString:'',
				options: {
					penColor:"rgb(0, 0, 0)",
					backgroundColor:"rgb(255,255,255)"
					// penColor: "#c0f",
				},
				
				// qrCodeImg: null,
				// mfaEnabled: "off",
				// mfaIntern: "on",
				language: this.$store.getters.language
			}
		},
		async created() {
			// this.$nextTick(function () {
			this.axiosShow('NAN')
			// });
			
		},
		updated(){
			this.axiosShow('NAN');
		},
		methods: {
			// infos
			async saveChanges() {
				var data = {
					mfaEnabled: this.mfaEnabled === "on" ? true : false,
					mfaIntern: this.mfaIntern === "on" ? true : false
				};
				await this.$store.dispatch('axiosPut', {
					domain: instanceClass,
					id: this.userId,
					data: data
				})
				.then(res => {
					this.user = res.data;
					this.$nextTick(() => {
						let msg = this.$t("user.label") + " "+this.userId;
						this.$store.dispatch('showToast', {
							type: 'success', message: this.$t('toast.updated.message', { obj: msg})
						});
					});
					
					// this.activateMfa();
				})
				.catch(error => {
					console.log('Error', error.response)
				})
			},
			async activateMfa() {
				await this.$store.dispatch('axiosPost', {
					url: '/api/mfa/activate'
				})
				.then(res => {
				if(res.data.message) {
					if(res.data.message === 'Mfa has successfully been enabled') {
						this.$nextTick(() => {
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('mfa.activated')
							});
						});
					} 
					else if (res.data.message === 'Mfa has already been enabled') {
						this.$nextTick(() => {
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('mfa.already.activated')
							});
						});
					} 
					else if(res.data.message === 'Mfa has not been enabled') {
						this.$nextTick(() => {
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('mfa.unsuccessful')
							});
						});
					}
				}
				})
				.catch(error => {
					console.log('Error', error.response)
					this.$nextTick(() => {
						this.$store.dispatch('showToast', {
							type: 'danger', message: this.$t('mfa.error')
						});
					});
				})
			},

			modalToggle(type) {
				// this.resetModal()
				this.modalType = type
				this.language = this.$store.getters.language
				if(this.active)
					this.active = false
				else{
					this.active = true
					this.$nextTick(function(){
						this.axiosShow(this.modalType)
					});
				}
			},
			async axiosShow(type) {
				try {
					if(this.userId) {
						await this.$store.dispatch('axiosGet', {
							domain: instanceClass, id: this.userId
						})
						.then(response => {
							this.row = response.data;
							this.user = response.data;
							if(this.user && this.user.prsPerson && this.user.prsPerson.prsPersonLib )
								this.prsLinkedName = this.user.prsPerson.prsPersonLib;
							// this.getPrsLinked()
							this.dataMapShow.infos.id = this.userId
							if (type === 'PWD'){
								this.dataMapShow.infos.title = "default.editPwd"
								this.dataMapShow.readOnlyShow = false
								this.dataMapShow.attrsList = [
									{ attrName: 'password', attrType: 'password', attrCol: 'col-md-12', attrValue: '', attrReadOnly: false, attrRequired: true, attrDisplay: true },
									{ attrName: 'passwordRepeat', attrType: 'password', attrCol: 'col-md-12', attrValue: '', attrReadOnly: false, attrRequired: true, attrDisplay: true }
								]
							} 
							else if (type === 'INFO'){
								this.dataMapShow.infos.title = "default.edit"
								this.dataMapShow.readOnlyShow = false
								this.dataMapShow.attrsList = [
									{ attrName: 'username', attrType: 'String', attrCol: 'col-md-12', attrValue: this.row.username,
									attrReadOnly: true, attrRequired: true, attrDisplay: true },
									{ attrName: 'email', attrType: 'String', attrCol: 'col-md-12', attrValue: this.row.email,
									attrReadOnly: true, attrRequired: true, attrDisplay: true },
									{ attrName: 'userTitle', attrType: 'String', attrCol: 'col-md-12', attrValue: this.row.userTitle, attrRequired: true, attrDisplay: true }
								]
							} 
							
							else if (type === 'uploadImgSign'){
								this.dataMapShow.infos.title = "default.uploadImgSign"
								this.dataMapShow.readOnlyShow = false
							}
							else if (type === 'signPad' || type === 'signPadPlus'){
								this.dataMapShow.infos.title = "default.signPad"
								this.dataMapShow.readOnlyShow = false
							}
							

						})
						.catch(error => {
							console.log(error)
						})
					}

				} 
				catch (e) {
					console.log(e)
				}
			},
			async handleSubmit() {
				const result = true //await this.v$.$validate()
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					// if(this.modalType === 'uploadImgSign')
					// 	this.submitFileSignature()
					// else
					this.axiosPost()
				}
			},
			//Sign
			async handleFileUpload(e) {
				try {
					const file = e.target.files[0];
					const reader = new FileReader();
					reader.onloadend = () => {
						// reader.result contains the data URL: "data:image/png;base64,iVBORw..."
						const base64String = reader.result//.split(',')[1];
						this.user.imgSignature = base64String;
						this.fileString = base64String;
					};
					reader.readAsDataURL(file);
				} 
				catch (error) {
					console.error("Error converting file:", error);
				}

			},
			async axiosPost() {
				let formdata;
				var dataEntries = {};
				if(this.modalType == "PWD" || this.modalType == "INFO"){
					formdata = new FormData(document.getElementById('modalForm'))
					dataEntries = Object.fromEntries(formdata)
				}
				try {
					if(this.userId) {
						// 1- Sign
						if(this.modalType === 'signPad' || this.modalType === 'uploadImgSign' || this.modalType === 'DEL'){
							if(this.modalType === 'signPad'){
								const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
								if(!isEmpty && data)
									this.fileString = data;
							}
							else if (this.modalType === 'DEL'){
								const proceed = window.confirm(this.$t("delete.confirm.message"));
								if(proceed)	
									this.fileString = ''
								else{
									console.log('pas confirmé');
									return
								}
							}

							dataEntries = {'imgSignature': this.fileString}
						}
						
						if(dataEntries) {
							// 2- PWD
							if(this.modalType == "PWD"){
								if(this.modalType == "PWD" && dataEntries.password === dataEntries.passwordRepeat) {
									console.log('validation same pwd success !')

								}
								else {
									this.$store.dispatch('showToast', {
										type: 'danger', message: this.$t('toast.same.password.message')
									});
									this.$store.dispatch('unloading')
									return
								}
							}
							// TRT
							await this.$store.dispatch('axiosPut', {
								domain: instanceClass,
								id: this.userId,
								data: dataEntries
							})
							.then(res => {
								this.user = res.data;
								if(this.modalType !== 'signPad' && this.modalType !== 'DEL' )
									this.modalToggle(this.modalType)

								this.$nextTick(() => {
									let msg = ''
									if(this.modalType === 'signPad' || this.modalType === 'uploadImgSign' || this.modalType === 'DEL')
										msg = "La signature de l' "
									msg = msg + this.$t(instanceClass + ".label") + " "+this.user.username;
									// let typeToast = 'success'
									if (this.modalType === 'DEL'){
										this.$store.dispatch('showToast', {
											type: 'danger', message: this.$t('toast.deleted.message', { obj: msg})
										});
									}
									else{
										this.$store.dispatch('showToast', {
											type: 'success', message: this.$t('toast.updated.message', { obj: msg})
										});
									}
									this.$store.dispatch('unloading')
									if(this.modalType === 'signPad')
										this.$router.go(0)
										// this.$router.push('/profile')
								});
							})
							.catch(error => {
								let errogetters = this.$store.getters.getErrorMsgFormatted(error);
							})
							this.$store.dispatch('unloading')
						}
					}
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			
			
			/*async submitFileSignature() {
				if(this.modalType === 'signPad'){
					const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
					if(!isEmpty && data){
						this.fileString = data;
						this.user.imgSignature = data;
					}
				}
				if (this.modalType === 'DEL' && !confirm(this.$t("delete.confirm.message")))
					console.log('pas confirmé');

				else{
					if (this.modalType === 'DEL')
						this.user.imgSignature = ''
					
					// console.log('this.fileString == ', this.fileString)
					// let data = {'imgSignature': this.user.imgSignature}
					let data = {'imgSignature': this.fileString}
					try {
						await this.$store.dispatch('axiosPut', {
							domain: instanceClass,
							id: this.userId,
							data: data
						})
						.then(res => {
							if (this.modalType === 'DEL'){
								this.modalToggle(this.modalType)
								this.$nextTick(() => {
									let msg = this.$t(instanceClass + ".label") + ""+this.userId;
									this.$store.dispatch('showToast', {
										type: 'danger', message: this.$t('toast.danger.message', { obj: msg})
									});
									this.$store.dispatch('unloading')
								});
							}
							
							else{
								this.modalToggle(this.modalType)
								this.$nextTick(() => {
									let msg = this.$t(instanceClass + ".label") + ""+this.userId;
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$store.dispatch('unloading')
								});
								
							}
							
						})
						.catch(error => {
							console.log('Error', error)
							let errogetters = this.$store.getters.getErrorMsgFormatted(error);
						}) 
						this.$store.dispatch('unloading')
					} 
					catch (e) {
						console.log('Error ', e)
					}
					this.modalType = 'INFO'
					this.showSignaturePad = false
				}
			},*/
			/*save() {
				const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
				this.user.imgSignature = data;
				this.submitFileSignature()
			},*/
			undo() {
				this.$refs.signaturePad.undoSignature();
			},
			change() {
				this.options = {penColor: "#00f",};
			},
			resume() {
				this.options = {penColor: "#c0f",};
			},


		}
	}
</script>
<style>
#signature {
	border: double 3px transparent;
	border-radius: 5px;
	background-image: linear-gradient(white, white),
		radial-gradient(circle at top left, #4bc5e8, #9f6274);
	background-origin: border-box;
	background-clip: content-box, border-box;
}

.container {
	width: "100%";
	padding: 8px 16px;
}

.buttons {
	display: flex;
	gap: 8px;
	justify-content: center;
	margin-top: 8px;
}
canvas {
	/*prevent interaction with the canvas*/
	pointer-events: auto;
}
</style>